export default {
    setMessage(response){
        commit('setMessage', response.message);
    }
}